export const BETA_SOURCES = [
  'microstrategy',
  'qlik',
];

export const isSourceBeta = (sourceName: string) => BETA_SOURCES.includes(sourceName.toLowerCase());
